import React from 'react'

export default function CuisineAds() {
    return (
        <div id="amzn-assoc-ad-bd6b3470-87db-40a5-94a6-5799aa0052ca"></div>
    )
}

